import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Image } from '../../models/image';
import { CrudService } from '../crud.service';

@Injectable({
  providedIn: 'root',
})
export class ImageService extends CrudService<Image> {
  protected basePath = 'image'; // Specific for ImageService
  public instanceType = 'image'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }
  getUploadUrl() {
    return this.buildUploadUrl('uploadImage');
  }

  removeImageSrc(filename: string, communeId: string) {
    return this.removeUploadedFile('imagePool', filename, communeId);
  }
}
